import React from "react";

export function getIcon(name) {
  switch (name) {
    case "arrow":
      return (
        <svg viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5 c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z"
            fill=""
          />
        </svg>
      );
    case "arrow-left":
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
          <path d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z" />
        </svg>
      );
    case "arrow-left-circle":
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path d="M0 12c0 6.627 5.373 12 12 12s12-5.373 12-12-5.373-12-12-12-12 5.373-12 12zm7.58 0l5.988-5.995 1.414 1.416-4.574 4.579 4.574 4.59-1.414 1.416-5.988-6.006z" />
        </svg>
      );
    case "arrow-forward":
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm2 12l-4.5 4.5 1.527 1.5 5.973-6-5.973-6-1.527 1.5 4.5 4.5z" />
        </svg>
      );
    case "arrow-backward":
      return (
        <svg class="svg-icon" viewBox="0 0 20 20">
          <path d="M11.739,13.962c-0.087,0.086-0.199,0.131-0.312,0.131c-0.112,0-0.226-0.045-0.312-0.131l-3.738-3.736c-0.173-0.173-0.173-0.454,0-0.626l3.559-3.562c0.173-0.175,0.454-0.173,0.626,0c0.173,0.172,0.173,0.451,0,0.624l-3.248,3.25l3.425,3.426C11.911,13.511,11.911,13.789,11.739,13.962 M18.406,10c0,4.644-3.763,8.406-8.406,8.406S1.594,14.644,1.594,10S5.356,1.594,10,1.594S18.406,5.356,18.406,10 M17.521,10c0-4.148-3.373-7.521-7.521-7.521c-4.148,0-7.521,3.374-7.521,7.521c0,4.148,3.374,7.521,7.521,7.521C14.147,17.521,17.521,14.148,17.521,10"></path>
        </svg>
      );
    default:
      return null;
  }
}

export function getBlob(number) {
  switch (number) {
    case "1":
      return (
        <svg viewBox="0 0 582 597" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="Group">
            <path
              id="Vector"
              d="M413.06 503.367C364.247 524.748 316.109 538.125 268.312 535.052C220.556 531.888 173.313 512.13 134.434 480.536C95.555 448.941 65.0396 405.511 59.1661 359.684C53.2927 313.857 72.1015 265.542 94.2557 220.553C116.45 175.472 141.847 133.544 180.034 102.037C218.221 70.5304 269.146 49.3122 314.176 57.9416C359.246 66.4796 398.368 104.733 435.688 141.869C473.14 178.952 508.79 214.917 529.35 261.622C549.869 308.418 555.258 366.045 533.289 409.369C511.28 452.783 461.833 482.077 413.06 503.367Z"
              fill="#fafafa"
            />
          </g>
        </svg>
        // <svg viewBox="0 0 582 597" fill="none" xmlns="http://www.w3.org/2000/svg">
        //   <g id="Group">
        //     <path
        //       id="Vector"
        //       d="M413.06 503.367C364.247 524.748 316.109 538.125 268.312 535.052C220.556 531.888 173.313 512.13 134.434 480.536C95.555 448.941 65.0396 405.511 59.1661 359.684C53.2927 313.857 72.1015 265.542 94.2557 220.553C116.45 175.472 141.847 133.544 180.034 102.037C218.221 70.5304 269.146 49.3122 314.176 57.9416C359.246 66.4796 398.368 104.733 435.688 141.869C473.14 178.952 508.79 214.917 529.35 261.622C549.869 308.418 555.258 366.045 533.289 409.369C511.28 452.783 461.833 482.077 413.06 503.367Z"
        //       fill="url(#img1)"
        //     />
        //   </g>
        //   <defs>
        //     <pattern id="img1" patternUnits="userSpaceOnUse" width="100" height="100">
        //       <image xlinkHref="/boat.jpg" x="0" y="0" width="100" height="100" />
        //     </pattern>
        //   </defs>
        // </svg>
      );
    default:
      return null;
  }
}

export function getWave(selected, cssClass) {
  switch (selected) {
    case "1":
      return (
        <svg className={cssClass} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path d="M0,224L80,213.3C160,203,320,181,480,186.7C640,192,800,224,960,245.3C1120,267,1280,277,1360,282.7L1440,288L1440,0L1360,0C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0L0,0Z"></path>
        </svg>
      );
    case "2":
      return (
        <svg className={cssClass} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path d="M0,128L48,138.7C96,149,192,171,288,165.3C384,160,480,128,576,117.3C672,107,768,117,864,128C960,139,1056,149,1152,160C1248,171,1344,181,1392,186.7L1440,192L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"></path>
        </svg>
      );
    case "3":
      return (
        <svg className={cssClass} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path d="M0,160L48,160C96,160,192,160,288,144C384,128,480,96,576,106.7C672,117,768,171,864,176C960,181,1056,139,1152,133.3C1248,128,1344,160,1392,176L1440,192L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"></path>
        </svg>
      );
    case "4":
      return (
        <svg className={cssClass} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path d="M0,224L48,224C96,224,192,224,288,224C384,224,480,224,576,234.7C672,245,768,267,864,261.3C960,256,1056,224,1152,202.7C1248,181,1344,171,1392,165.3L1440,160L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"></path>
        </svg>
      );
    case "5":
      return (
        <svg className={cssClass} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path d="M0,96L48,90.7C96,85,192,75,288,101.3C384,128,480,192,576,208C672,224,768,192,864,197.3C960,203,1056,245,1152,229.3C1248,213,1344,139,1392,101.3L1440,64L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"></path>
        </svg>
      );
    case "6":
      return (
        <svg className={cssClass} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path d="M0,224L48,202.7C96,181,192,139,288,138.7C384,139,480,181,576,176C672,171,768,117,864,128C960,139,1056,213,1152,208C1248,203,1344,117,1392,74.7L1440,32L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"></path>
        </svg>
      );
    case "7":
      return (
        <svg className={cssClass} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path d="M0,256L60,250.7C120,245,240,235,360,229.3C480,224,600,224,720,208C840,192,960,160,1080,160C1200,160,1320,192,1380,208L1440,224L1440,0L1380,0C1320,0,1200,0,1080,0C960,0,840,0,720,0C600,0,480,0,360,0C240,0,120,0,60,0L0,0Z"></path>
        </svg>
      );
    case "8":
      return (
        <svg className={cssClass} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path d="M0,256L60,229.3C120,203,240,149,360,128C480,107,600,117,720,101.3C840,85,960,43,1080,53.3C1200,64,1320,128,1380,160L1440,192L1440,0L1380,0C1320,0,1200,0,1080,0C960,0,840,0,720,0C600,0,480,0,360,0C240,0,120,0,60,0L0,0Z"></path>
        </svg>
      );
    case "9":
      return (
        <svg className={cssClass} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path d="M0,64L80,80C160,96,320,128,480,165.3C640,203,800,245,960,229.3C1120,213,1280,139,1360,101.3L1440,64L1440,0L1360,0C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0L0,0Z"></path>
        </svg>
      );
    case "10":
      return (
        <svg className={cssClass} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path d="M0,32L34.3,48C68.6,64,137,96,206,96C274.3,96,343,64,411,69.3C480,75,549,117,617,133.3C685.7,149,754,139,823,149.3C891.4,160,960,192,1029,181.3C1097.1,171,1166,117,1234,106.7C1302.9,96,1371,128,1406,144L1440,160L1440,0L1405.7,0C1371.4,0,1303,0,1234,0C1165.7,0,1097,0,1029,0C960,0,891,0,823,0C754.3,0,686,0,617,0C548.6,0,480,0,411,0C342.9,0,274,0,206,0C137.1,0,69,0,34,0L0,0Z"></path>
        </svg>
      );
    case "11":
      return (
        <svg className={cssClass} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path d="M0,64L80,69.3C160,75,320,85,480,96C640,107,800,117,960,117.3C1120,117,1280,107,1360,101.3L1440,96L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path>
        </svg>
      );
    case "12":
      return (
        <svg className={cssClass} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path d="M0,160L80,144C160,128,320,96,480,90.7C640,85,800,107,960,122.7C1120,139,1280,149,1360,154.7L1440,160L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path>
        </svg>
      );
    case "13":
      return (
        <svg className={cssClass} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path d="M0,160L80,144C160,128,320,96,480,90.7C640,85,800,107,960,122.7C1120,139,1280,149,1360,154.7L1440,160L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path>
        </svg>
      );
    default:
      return <p>Missing svg information</p>;
  }
}
